import React, { useEffect, useState } from 'react'
import axios from 'axios';

const withTenant = (Component) => {

    const Wrapper =  (props)=>{ 
        //console.log('withTenant: => Starting');
        const pathname = window.location.pathname;
        const usernameTenant  = pathname.split('/')[1];
        const [isTenant,setIsTenant] = useState(false);

        useEffect(()=>{
            let isActive = true;
            const loadTenant = async () => {
                const cachedTenantRaw = localStorage.getItem('tenant');
                let cachedTenant = null;
                try {
                    cachedTenant = cachedTenantRaw ? JSON.parse(cachedTenantRaw) : null;
                } catch {
                    cachedTenant = null;
                }
                if(!usernameTenant){
                    if(cachedTenant){
                        if(isActive) setIsTenant(true);
                        return;
                    }
                    window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
                    return;
                }
                try{
                    const res = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/username/${usernameTenant}`);
                    const _data = res?.data?.data;
                    if(!isActive) return;
                    if(_data){
                        localStorage.setItem('tenant',JSON.stringify( _data));
                        setIsTenant(true);
                        return;
                    }
                }catch(err){
                    if(!isActive) return;
                    console.log(err);
                }
                if(cachedTenant && cachedTenant?.username === usernameTenant){
                    setIsTenant(true);
                    return;
                }
                window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
            };
            loadTenant();
            return () => {
                isActive = false;
            };
        },[usernameTenant]);

        if(isTenant){
            //console.log('withTenant: => is Ready');
            return   <Component {...props} /> 
        }
        

    }
    return Wrapper;
}

export default withTenant
